import React, { useEffect, useState } from "react";
import AdditionalDetailsFields from "../../../constants/DeliveryDrivers/AdditionalDetailsFields.json";
import { connect } from "react-redux";
import Textarea from "sushiweb/InputTypes/Textarea";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import Input from "sushiweb/InputTypes/Input";
import variables from "../../../constants/assets/variables";
import {
  addMandatoryNestedKeys,
  getObjectsDifference,
  getPath,
  getReadableDateTime,
  setNestedKeyValue,
} from "../../../utils";
import {
  DriverBasicDetailsContainer,
  FieldHolder,
} from "../../../constants/assets/DriverDetailsContainers";
import * as DeliveryDriversActions from "../../../store/actions/DeliveryDrivers";
import * as UserActions from "../../../store/actions/User";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import OTPModalWithPhoneNumber from "../../Common/OTPModalWithPhoneNumber";
import ErrorMsgs from "../../../constants/Errors.json";
import ErrorModal from "../../Common/ErrorModal";
import moment from "moment";
import { handleValidations, nestedMandatoryKey } from "../utils";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import {
  FieldsContainer,
  FieldsSection,
} from "../../../constants/assets/containers";

const DriverAdditionalDetails = ({
  getDriverAdditionalDetails,
  driverAdditionalDetails,
  editState,
  driverProfessions,
  driverEducations,
  driverEducationQualifications,
  getDriverProfessions,
  getDriverEducationQualifications,
  getDriverEducations,
  saveState,
  setSaveState,
  updateDriverAdditionalDetails,
  setStatus,
  getOTPDriverAdditionalDetails,
  driverBasicDetails,
  allMenuActions,
}) => {
  const { id } = useParams();
  const [initialState, setInitialState] = useState({});
  const [otpModal, setOtpModal] = useState(false);
  const [updatedPhoneNo, setUpdatedPhoneNo] = useState("");
  const [errors, setErrors] = useState([]);
  const allActions = MenuActionsMappings[MenuNames.DRIVER];

  const getValue = (field) => {
    const val = getPath(initialState, field.key, "");
    if (field.dateField) {
      return getReadableDateTime(val);
    } else return val;
  };

  const getDropdownVal = (value, options, field) => {
    const selectedOption = options.find(
      (item) => item[field.valueKey] === value
    );
    return field && selectedOption && selectedOption[field.labelKey];
  };

  const getITRStatusOptionLabel = (key) => {
    switch (key) {
      case "INITIATED":
        return "Initiated";
      case "PROCESSING":
        return "Processing";
      case "E_FILING_SUCCESS":
        return "E-filing Success";
      case "E_VERIFICATION_SUCCESS":
        return "E-verification Success";
      case "PAYMENT_SUCCESS":
        return "Payment Success";
      case "FAILED":
        return "Failed";
      case "UNREGISTERED":
        return "Unregistered";
      case "PRE_VALIDATION_PENDING":
        return "Pre-validation Pending";
      case "COMPLETE":
        return "Complete";
      default:
        return "Unregistered";
    }
  };

  const getITRFieldOptions = (selectedValue = "UNREGISTERED") => {
    if (selectedValue === "") selectedValue = "UNREGISTERED";
    let options = [
      { key: selectedValue, label: getITRStatusOptionLabel(selectedValue) },
    ];
    if (selectedValue === "INITIATED" || selectedValue === "PROCESSING") {
      let resetValue = "UNREGISTERED";
      options.push({
        key: resetValue,
        label: getITRStatusOptionLabel(resetValue),
      });
    }
    return options;
  };

  const getFieldOptions = (field, selectedValue = "") => {
    if (field.options.length > 0) {
      return field.options;
    }
    switch (field.key) {
      case "profession_id":
        return driverProfessions;
      case "educational_field_id":
        return driverEducations;
      case "educational_qualification_id":
        return driverEducationQualifications;
      case "itr_status":
        return getITRFieldOptions(selectedValue);
      default:
        return [];
    }
  };

  const handleChange = (key, val, isNumber, isDateField) => {
    const values = { ...initialState };
    let finalVal = val;
    if (isNumber === true && finalVal) {
      finalVal = parseInt(finalVal);
    }
    if (isDateField === true && finalVal) {
      finalVal = moment.utc(finalVal.toLocaleString()).format();
    }
    setNestedKeyValue(values, key, finalVal);
    setInitialState(values);
  };

  const handleSubmit = () => {
    const payload = getObjectsDifference(
      driverAdditionalDetails,
      initialState,
      "id"
    );
    addMandatoryNestedKeys(payload, initialState, nestedMandatoryKey);
    const validationErrors = handleValidations(
      initialState,
      "additionalDetails",
      driverBasicDetails
    );
    if (Object.keys(payload).length > 0 && validationErrors.length === 0) {
      updateDriverAdditionalDetails(id, payload, initialState).then((res) => {
        if (res) {
          if (getPath(res, "status.code", undefined) === 897) {
            setUpdatedPhoneNo("");
            setStatus({
              type: "error",
              message: ErrorMsgs.OTP_REQUIRED,
            });
            setOtpModal(true); //show otp modal and make getotp call
            setTimeout(
              () =>
                getOTPDriverAdditionalDetails(id, payload).then((res) =>
                  setUpdatedPhoneNo(getPath(res, "OTP.sent_to", undefined))
                ),
              1000
            );
          }
        }
      });
    } else if (Object.keys(payload).length === 0) {
      if (validationErrors.length > 0) {
        setErrors(validationErrors);
      } else {
        const err = [...errors];
        err.push("Error! You didn't make any change");
        setErrors(err);
      }
    } else {
      setErrors(validationErrors);
    }
    setSaveState(false);
  };

  const checkIfTextAreaDisabled = (item) => {
    if (item.key === "description") {
      return allMenuActions[allActions["DRIVER_DESCRIPTION_EDIT"]]
        ? item.disabled
        : true;
    }
    return item.disabled;
  };

  const getField = (type, field) => {
    switch (type) {
      case "textarea":
        return (
          <Textarea
            id="sushi-textarea"
            data-testid={field.id}
            rows={1}
            fullWidth={true}
            disabled={editState ? checkIfTextAreaDisabled(field) : true}
            onChange={(e) => handleChange(field.key, e, field.isNumber)}
            value={getValue(field)}
          />
        );
      case "text":
        return (
          <Input
            borderColor={variables.primaryColor}
            id="sushi-input"
            data-testid={field.id}
            fullWidth={true}
            disabled={editState && field.disabled}
            onChange={(val) => handleChange(field.key, val, field.isNumber)}
            value={getValue(field)}
          />
        );
      case "calender":
        return (
          <Input
            id="sushi-input"
            className="calender-input"
            data-testid={field.id}
            fullWidth={true}
            disabled={editState && field.disabled}
            // onChange={(e) => handleChange(field.key, e)}
            value={moment(getPath(initialState, field.key, "")).format(
              "YYYY-MM-DD"
            )}
            type="date"
            onChange={(val) =>
              handleChange(field.key, val, field.isNumber, field.dateField)
            }
          />
        );
      case "dropdown":
        return (
          <PaginatedReactDropdown
            options={getFieldOptions(
              field,
              getPath(initialState, field.key, "")
            )}
            disabled={field.disabled}
            labelKey={field.labelKey}
            valueKey={field.valueKey}
            value={getDropdownVal(
              getPath(initialState, field.key, ""),
              getFieldOptions(field, getPath(initialState, field.key, "")),
              field
            )}
            handleChange={handleChange}
            placeholder=""
            keyToChange={field.key}
            showCross={true}
            id={`driverDetailsDropdown${field.labelKey}`}
          />
        );
      default:
        return "";
    }
  };

  const handleCloseOTPModal = () => {
    setOtpModal(false);
  };

  const handleOTPVerify = (otp) => {
    //make update call with otp
    const payload = getObjectsDifference(
      driverAdditionalDetails,
      initialState,
      "id"
    );
    addMandatoryNestedKeys(payload, initialState, nestedMandatoryKey);
    updateDriverAdditionalDetails(id, payload, initialState, otp).then(
      (res) => {
        if (res) {
          handleCloseOTPModal();
          setSaveState(false);
          setUpdatedPhoneNo("");
        }
      }
    );
  };

  const getOTP = () => {
    // make post call to get otp
    const payload = getObjectsDifference(
      driverAdditionalDetails,
      initialState,
      "id"
    );
    addMandatoryNestedKeys(payload, initialState, nestedMandatoryKey);
    getOTPDriverAdditionalDetails(id, payload, true);
  };

  const handleErrorModalSubmit = () => {
    setErrors([]);
  };

  const rollBackInitialState = () => {
    const activeDetailsCopy = JSON.parse(
      JSON.stringify(driverAdditionalDetails)
    );
    setInitialState(activeDetailsCopy);
  };

  useEffect(() => {
    if (Object.keys(driverAdditionalDetails).length === 0) {
      getDriverAdditionalDetails(id);
    }
    driverProfessions.length === 0 && getDriverProfessions();
    driverEducations.length === 0 && getDriverEducations();
    driverEducationQualifications.length === 0 &&
      getDriverEducationQualifications();
  }, []);

  useEffect(() => {
    rollBackInitialState();
  }, [driverAdditionalDetails]);

  //to handle click on save button
  useEffect(() => {
    saveState && handleSubmit();
  }, [saveState]);

  //to handle click on cancel button
  useEffect(() => {
    !editState && rollBackInitialState();
  }, [editState]);

  return (
    <DriverAdditionalDetailsContainer
      editState={editState}
      className={!editState && "no-edit"}
    >
      {AdditionalDetailsFields.sections.map((section, index) => {
        return (
          <FieldsSection key={index}>
            {section.name && <p>{section.name}</p>}
            <FieldsContainer>
              {section.fields.map((field, fieldIdx) => {
                return (
                  <FieldHolder noBorder={field.noBorder} justify="flex-start">
                    {field.placeholder && (
                      <span>
                        {field.placeholder}
                        {field.isMandatory && <sup>*</sup>}
                      </span>
                    )}
                    {getField(field.type, field)}
                  </FieldHolder>
                );
              })}
            </FieldsContainer>
          </FieldsSection>
        );
      })}
      {otpModal && (
        <OTPModalWithPhoneNumber
          handleOTPVerify={handleOTPVerify}
          getOTP={getOTP}
          handleClose={handleCloseOTPModal}
          heading="Verify OTP to update details"
          phone={updatedPhoneNo}
        />
      )}
      {errors.length > 0 && (
        <ErrorModal
          handleSubmit={handleErrorModalSubmit}
          heading="Error while saving"
          errors={errors}
        />
      )}
    </DriverAdditionalDetailsContainer>
  );
};

const DriverAdditionalDetailsContainer = styled(DriverBasicDetailsContainer)``;

function mapStateToProps(state) {
  const { DeliveryDrivers, MenuActions } = state;
  return {
    driverAdditionalDetails: DeliveryDrivers.driverAdditionalDetails,
    driverEducationQualifications:
      DeliveryDrivers.driverEducationQualifications,
    driverEducations: DeliveryDrivers.driverEducations,
    driverProfessions: DeliveryDrivers.driverProfessions,
    driverBasicDetails: DeliveryDrivers.driverBasicDetails,
    allMenuActions: MenuActions.allMenuActions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverAdditionalDetails: bindActionCreators(
      DeliveryDriversActions.getDriverAdditionalDetails,
      dispatch
    ),
    getDriverProfessions: bindActionCreators(
      DeliveryDriversActions.getDriverProfessions,
      dispatch
    ),
    getDriverEducations: bindActionCreators(
      DeliveryDriversActions.getDriverEducations,
      dispatch
    ),
    getDriverEducationQualifications: bindActionCreators(
      DeliveryDriversActions.getDriverEducationQualifications,
      dispatch
    ),
    updateDriverAdditionalDetails: bindActionCreators(
      DeliveryDriversActions.updateDriverAdditionalDetails,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    getOTPDriverAdditionalDetails: bindActionCreators(
      DeliveryDriversActions.getOTPDriverAdditionalDetails,
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverAdditionalDetails);
